'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Numeral = require('./Numeral');

var _Numeral2 = _interopRequireDefault(_Numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numeral = global.numeral;
if (!numeral) {
  throw new Error('Numeral is required in global variable');
}

var FormattedNumberComponent = function (_NumeralFieldComponen) {
  (0, _inherits3.default)(FormattedNumberComponent, _NumeralFieldComponen);

  function FormattedNumberComponent() {
    (0, _classCallCheck3.default)(this, FormattedNumberComponent);
    return (0, _possibleConstructorReturn3.default)(this, (FormattedNumberComponent.__proto__ || Object.getPrototypeOf(FormattedNumberComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(FormattedNumberComponent, [{
    key: 'unformatValue',
    value: function unformatValue(label) {
      return label === '' ? undefined : numeral._.stringToNumber(label);
    }
  }, {
    key: 'formatValue',
    value: function formatValue(real) {
      return numeral(real) ? numeral(real).format('0,0.[000000000000000000000]') : '';
    }
  }]);
  return FormattedNumberComponent;
}(_Numeral2.default);

exports.default = FormattedNumberComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/fields/numeral/Number.js
// module id = 696
// module chunks = 0